import React, { ReactNode } from "react";
import { Helmet } from "react-helmet";
import Header from "./Header";
import Footer from "./Footer";

interface PageContainerProps {
    children?: ReactNode;
}

export default function PageContainer({ children = null }: PageContainerProps) {
    return (
        <div className="root">

            <Helmet>
                <title>IKEA - AutoMail</title>
            </Helmet>

            <div id="pg" className="automail">
                <Header />

                <main id="pg-main">
                    {children}
                </main>

                <Footer />
            </div>
        </div>
    );
}